import { EMPLOYEE_MEASURE_RESULT_ROUTER, EMPLOYEE_MEASURE_ROUTER } from "@Router/routerPath";
import { EmployeeMeasurementPage } from "@Local/Measurement";

const EmployeeMeasurementRouter = [
    {
        description: '教練量身',
        static: true,
        path: EMPLOYEE_MEASURE_ROUTER,
        href: EMPLOYEE_MEASURE_ROUTER,
        as: EmployeeMeasurementPage,
    },
    {
        description: '教練量身結果',
        static: true,
        path: EMPLOYEE_MEASURE_RESULT_ROUTER,
        href: EMPLOYEE_MEASURE_RESULT_ROUTER,
        as: EmployeeMeasurementPage,
    },
]

export default EmployeeMeasurementRouter;